export const getPublicPath = () => {
  return process.env.PUBLIC_PATH;
};

export default getPublicPath;
